import { AllieWidgetProps } from './Widget.types';
import { AllieText } from '../Text';
import { IconsType } from './IconsType/IconsType';
import {
  StyledAllieWidget,
  StyledAllieWidgetHeader,
  StyledAllieWidgetIcon,
  StyledAllieWidgetLeftSide,
  StyledAllieWidgetLeftSideContent,
  StyledAllieWidgetLeftSideSubtitle,
  StyledAllieWidgetRightSide,
} from './Widget.styles';

export const AllieWidget: React.FC<AllieWidgetProps> = ({
  title,
  subtitle,
  content,
  iconType,
  color,
  viewAllHandler,
  viewAllText,
}) => {
  const SvgIcon = IconsType(iconType ?? 'status', color);
  return (
    <StyledAllieWidget>
      <StyledAllieWidgetHeader>
        <StyledAllieWidgetIcon>{SvgIcon}</StyledAllieWidgetIcon>
        <AllieText color="neutral" type="h4" weight={500}>
          {title}
        </AllieText>
      </StyledAllieWidgetHeader>
      <StyledAllieWidgetLeftSide>
        <StyledAllieWidgetLeftSideSubtitle color="neutral-90" type="h3">
          {subtitle}
        </StyledAllieWidgetLeftSideSubtitle>
        <StyledAllieWidgetLeftSideContent>{content}</StyledAllieWidgetLeftSideContent>
      </StyledAllieWidgetLeftSide>
      <StyledAllieWidgetRightSide>
        {viewAllHandler && (
          <AllieText className="view-all" color="neutral" type="h4" onClick={viewAllHandler}>
            {viewAllText}
          </AllieText>
        )}
      </StyledAllieWidgetRightSide>
    </StyledAllieWidget>
  );
};
